import { ColumnFilterWrapper } from "@shared/ui/filters/ColumnFilterWrapper";
import { Select } from "@shared/ui";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";

type BriefOption = {
  label: string;
  value: string;
};

type PayoutCampaignColumnFilterProps = {
  confirm: () => void;
  close: () => void;
  options: BriefOption[];
  selectedBriefIds: string[];
  onApply: (briefIds: string[]) => void;
  briefSearch: string;
  onBriefSearchChange: (value: string) => void;
  isLoading?: boolean;
};

export function PayoutCampaignColumnFilter({
  confirm,
  close,
  options,
  selectedBriefIds,
  onApply,
  briefSearch,
  onBriefSearchChange,
  isLoading = false,
}: PayoutCampaignColumnFilterProps) {
  const [draftIds, setDraftIds] = useState<string[]>(selectedBriefIds);

  useEffect(() => {
    setDraftIds(selectedBriefIds);
  }, [selectedBriefIds]);

  return (
    <ColumnFilterWrapper
      title="Campaign"
      filterCount={draftIds.length}
      isFiltered={draftIds.length > 0}
      confirm={confirm}
      close={close}
      onApply={() => {
        onApply(draftIds);
        confirm();
      }}
      onReset={() => {
        setDraftIds([]);
        onBriefSearchChange("");
        onApply([]);
        confirm();
      }}
    >
      <div className={styles.field}>
        <Select
          mode="multiple"
          allowClear
          showSearch
          filterOption={false}
          loading={isLoading}
          placeholder="Search campaigns…"
          options={options}
          value={draftIds}
          searchValue={briefSearch}
          onSearch={onBriefSearchChange}
          onChange={(values) => setDraftIds(values as string[])}
          className={styles.select}
          maxTagCount="responsive"
        />
      </div>
    </ColumnFilterWrapper>
  );
}
